class BlockPress {
    constructor(blockEl) {
        this.blockEl = blockEl;
        this.links = this.blockEl.querySelectorAll('.block-press__link');
        this.loadMoreBtn = this.blockEl.querySelector('button.load-more');
        this.handleClick();
    }

    handleClick = () => {
        let currentSection = 2;

        this.loadMoreBtn.addEventListener('click', () => {
            this.links.forEach(i => {
                if (i.dataset.section == currentSection) {
                    i.removeAttribute('hidden');
                }
            });

            currentSection++;
        });
    };
}

export default BlockPress;